import * as Yup from 'yup';
import { formikRequired } from '../SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    notes: formikRequired,
  });

export default Validator;
